/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_ZendeskInputs */

const en_node_zendesk = /** @type {(inputs: Node_ZendeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zendesk`)
};

/**
* | output |
* | --- |
* | "Zendesk" |
*
* @param {Node_ZendeskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_zendesk = /** @type {((inputs?: Node_ZendeskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_ZendeskInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_zendesk(inputs)
});